import { Component, computed, inject } from '@angular/core'
import { NgTemplateOutlet } from '@angular/common'
import { RouterModule } from '@angular/router'
import { NavContextService } from '../../services/nav-context.service'
import { VideoOnlyBadgeComponent } from '../video-only-badge/video-only-badge.component'

@Component({
  selector: 'app-context-indicator',
  standalone: true,
  imports: [RouterModule, NgTemplateOutlet, VideoOnlyBadgeComponent],
  templateUrl: './context-indicator.component.html',
  styleUrl: './context-indicator.component.scss',
})
export class ContextIndicatorComponent {
  readonly navCtx = inject(NavContextService)

  /** What a screen reader hears for the match crests: "APOEL v AEL, 2–1". */
  readonly versusLabel = computed(() => {
    const home = this.navCtx.entityLabel()
    const away = this.navCtx.entityLabel2()
    if (!home || !away) return 'Match overview'
    const score = this.navCtx.versusScore()
    return score ? `${home} v ${away}, ${score}` : `${home} v ${away}`
  })
}
